import { createTheme, responsiveFontSizes } from "@mui/material/styles";

import components from "./components";
import layout from "./layout";
import palette from "./palette";
import typography from "./typography";

const theme = responsiveFontSizes(
  createTheme({
    components,
    palette,
    shape: {
      borderRadius: 12,
    },
    typography,
    zIndex: {
      appBar: 1200,
      drawer: 1100,
    },
    ...layout,
  }),
);

export default theme;
